import { render, staticRenderFns } from "./ReturnShipment.vue?vue&type=template&id=7840506c&scoped=true&"
import script from "./ReturnShipment.vue?vue&type=script&lang=js&"
export * from "./ReturnShipment.vue?vue&type=script&lang=js&"
import style0 from "./ReturnShipment.vue?vue&type=style&index=0&id=7840506c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7840506c",
  null
  
)

export default component.exports